import type * as React from 'react';

export const allowedColors = [
	'blue',
	'yellow',
	'red',
	'green',
	'purple',
	'gray',
	'darkGray',
	'tertiary',
	'pink',
	'orange',
	'teal',
	'navy',
	'golden-brown',
	'indigo',
	'steelBlue',
	'aqua',
] as const;

export type TAllowedColors = (typeof allowedColors)[number];

export const allowedTypes = ['basic', 'outline'] as const;
export type TTypes = (typeof allowedTypes)[number];

export interface TagProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'color'> {
	children: React.ReactNode;
	color: TAllowedColors;
	type?: TTypes;
	padding?: string;
	fontWeight?: string | number;
	leftIcon?: React.ReactNode | null;
	rightIcon?: React.ReactNode | null;
	truncate?: boolean;
	maxWidth?: string;
	className?: string;
}
